'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    text-align: justify;\n    text-justify: inter-word;\n    word-break:break-word;\n'], ['\n    text-align: justify;\n    text-justify: inter-word;\n    word-break:break-word;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _link = require('../link');

var _link2 = _interopRequireDefault(_link);

var _label = require('../text/label');

var _label2 = _interopRequireDefault(_label);

var _alignments = require('../../constants/alignments');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StaticLabel = (0, _styledComponents2.default)(_label2.default)(_templateObject);

var MultiLink = function (_React$Component) {
    _inherits(MultiLink, _React$Component);

    function MultiLink() {
        _classCallCheck(this, MultiLink);

        return _possibleConstructorReturn(this, (MultiLink.__proto__ || Object.getPrototypeOf(MultiLink)).apply(this, arguments));
    }

    _createClass(MultiLink, [{
        key: 'render',
        value: function render() {
            var label = this.props.text;
            var target = this.props.href;
            var alignment = this.props.textAlign || _alignments.Alignments.center;
            var newTab = this.props.newTab;
            var size = this.props.size;
            var top = this.props.top;
            var bottom = this.props.bottom;
            var seperator = ",";
            var nested = false;
            var valueObj = {};
            var linkLabel = [];
            if (label && label.includes('@&') && label.includes('&@')) {
                nested = true;

                target = target.split(seperator);

                var openChar = label.match(/@&/g).length;
                var closeChar = label.match(/&@/g).length;

                if (openChar === closeChar && closeChar === target.length) {
                    for (var i = 0; i < target.length; i++) {
                        var links = label.substring(label.indexOf('@&') + 2, label.indexOf('&@'));
                        var placeholder = '{link' + (i + 1) + '}';
                        label = label.replace('@&' + links + '&@', placeholder);
                        linkLabel.push(links);
                    }
                }

                label = label.replace(/@&|&@/g, "");

                for (var _i = 0; _i < linkLabel.length; _i++) {
                    var link = "link" + (_i + 1);
                    valueObj[link] = _react2.default.createElement(_link2.default, { inline: true, text: linkLabel[_i], textAlign: alignment, size: size, top: top, bottom: bottom, href: target[_i], newTab: newTab, secondaryStyle: true });
                }
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                nested ? _react2.default.createElement(StaticLabel, { size: size, top: top, bottom: bottom, textAlign: alignment,
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: label,
                        values: valueObj
                    })
                }) : _react2.default.createElement(_link2.default, { text: label, textAlign: alignment, size: size, top: top, bottom: bottom, href: target, newTab: newTab, secondaryStyle: true })
            );
        }
    }]);

    return MultiLink;
}(_react2.default.Component);

exports.default = MultiLink;